import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useReunion } from '../contexts/ReunionContext';
import type { FeatureToggles } from '../types/reunion';

interface FeatureGateProps {
  feature: keyof FeatureToggles;
  children: ReactNode;
}

export function FeatureGate({ feature, children }: FeatureGateProps) {
  const { reunion } = useReunion();

  // While reunion data is loading, render children to avoid flash
  if (!reunion) return <>{children}</>;

  const enabled = reunion.featureToggles?.[feature] ?? true;

  if (enabled) return <>{children}</>;

  return (
    <div className="section-padding">
      <div className="container-main flex flex-col items-center justify-center min-h-[40vh] text-center">
        <div className="bg-slate-100 rounded-full p-4 mb-4">
          <svg className="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-slate-700 mb-2">Feature Not Available</h2>
        <p className="text-slate-500 mb-6 max-w-md">
          This feature is not currently enabled for this reunion. Please check back later or contact your reunion organizer.
        </p>
        <Link
          to="/dashboard"
          className="bg-primary text-white px-6 py-2.5 rounded-lg font-bold text-sm hover:bg-primary/90 transition-all"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
